
import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";

interface StudioInfoProps {
  onPricingClick: () => void;
  currentTitle?: string;
}

export const StudioInfo = ({ onPricingClick, currentTitle }: StudioInfoProps) => {
  const showFileName = currentTitle && currentTitle !== "Untitled Project";

  return (
    <div className="flex items-center justify-between flex-1">
      <div className="flex items-center justify-between flex-1">
        <div className="flex flex-col">
          <div className="flex items-center gap-3.5">
            <div className="flex flex-col">
              <span className="text-base font-medium tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-600 leading-none animate-gradient-xy">
                Studio
              </span>
              <span className="text-[8px] text-gray-400 leading-none mt-0.5">
                by thePlasticsFella
              </span>
            </div>
            
            <button
              onClick={onPricingClick}
              className="min-w-[60px] h-[22px] bg-indigo-600 hover:bg-indigo-700 text-white text-[10px] font-medium rounded-full px-2 flex items-center justify-center transition-all duration-300"
            >
              <Sparkles className="h-2 w-2 mr-1 text-white/90" />
              Go Pro
            </button>
          </div>
        </div>

        {showFileName && (
          <div className="flex items-center justify-end ml-8">
            <span className="text-sm text-gray-500 leading-none font-light max-w-[180px] truncate">
              {currentTitle}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
